<template>
    <div>
        <div class="top" :style="topBg">
            <div class="main-width">
                <div class="py-5">
                    <VBreadcrumb :options="[
                        { label: '首页', to: '/' },
                        { label: city.shortname }
                    ]"></VBreadcrumb>
                </div>
            </div>
            <section class="main-width harbor">
                <img class="poster" :src="city.images"/>
                <div class="city-detail">
                    <h1 class="name mb-1">{{ city.shortname }}</h1>
                    <h2 class="en">{{ city.pinyin }}</h2>
                    <div class="relative">
                        <div class="information" :class="{active:infoExpand}">
                            <div class="desc" ref="descRef" v-html="city.desc"></div>
                            <div class="text-right" v-if="infoExpandVisiblity">
                                <button v-if="!infoExpand" class="more" @click="toggleExpand">查看更多 <i class="el-icon-arrow-down"></i></button>
                                <button v-else class="more" @click="toggleExpand">关闭更多 <i class="el-icon-arrow-up"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="box">
            <div class="main-width">
                <div class="holday-filter">
                    <div class="filter-row">
                        <filter-bar
                            name="邮轮公司"
                            :options="filter.brand"
                            :is-all="queryData.company.length == 0"
                            @on-clear="handleClearQuery('company')"
                            v-if="filter.brand && filter.brand.length"
                        >
                            <template #item="{option}">
                                <v-checkbox
                                    :val="option.company_id"
                                    v-model="queryData.company"
                                    @change="handleFitlerChange"
                                >
                                    {{ option.name }}
                                </v-checkbox>
                            </template>
                        </filter-bar>
                        <filter-bar
                            name="出游天数"
                            :options="filter.travel_days"
                            :is-all="queryData.days.length == 0"
                            @on-clear="handleClearQuery('days')"
                            v-if="filter.travel_days && filter.travel_days.length"
                        >
                            <template #item="{option}">
                            <v-checkbox
                                :val="option.val"
                                v-model="queryData.days"
                                @change="handleFitlerChange"
                            >
                                {{ option.value }}
                            </v-checkbox>
                            </template>
                        </filter-bar>
                        <filter-bar
                            name="出游日期"
                            :options="filter.date"
                            :is-all="queryData.date.length == 0"
                            @on-clear="handleClearQuery('date')"
                            type="group"
                            v-if="filter.date && filter.date.length"
                        >
                            <template #item="{option}">
                            <v-checkbox
                                :val="option.value"
                                v-model="queryData.date"
                                @change="handleFitlerChange"
                            >
                                {{ option.name }}
                            </v-checkbox>
                            </template>
                        </filter-bar>
                    </div>
                </div>
                <product-list
                    :pageIndex="queryData.page_index"
                    :loading="loading"
                    :initSort='["5"]'
                    sort_type="4"
                    @change="listChange"
                    :listData="listData"
                >
                </product-list>
            </div>
        </section>
    </div>
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import FilterBar from "@/components/product/filterBar";
import ProductList from "@/components/product/productList";
import calcTextLine from '@/utils/calcTextLine'
import ProductItem from '@/components/product/prodcutItem.vue'
import VBreadcrumb from '@/components/VBreadcrumb.vue'

import { getHarborDetail, getProductList } from "@/services/harbor";

const bgColors = ['#EAEEFD','#D6EEEE','#EEEED7','#F6E7E0','#F5E0F2']
function randomNum(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default defineComponent({
    name: 'holidayRoute',
    auth: false,
    head: {},
    layout: 'Main',
    components: { FilterBar,ProductList,ProductItem, VBreadcrumb},
    setup() {
        useMeta(() => ({
			title: "热门港口"
		}));
    },
    data(){
        return {
            infoExpand:false,
            infoExpandVisiblity:false,
            queryData:{
                company:[],
                days:[],
                sort_type:'4',
                sort_name:'5',
                page_index:1,
                page_size:10,
                date:[],
                city:null
            },
            city:{},
            filter:{},
            loading:false,
            listData:{},
            topBg:{},
        }
    },
    methods:{
        toggleExpand(){
            if(this.infoExpand){
                this.$refs.descRef.scrollTop = 0
            }
            this.infoExpand = !this.infoExpand
        },
        handleClearQuery(key) {
            this.queryData[key] = [];
            this.$nextTick(this.handleFitlerChange);
        },
        handleFitlerChange() {
            this.queryData.page_index = 1
            this.getLists(this.queryData)
        },
        listChange(val){
            this.queryData.page_index = val.page_index
            this.queryData.page_size = val.page_size
            this.queryData.sort_name = val.sort_name
            this.queryData.sort_type = val.sort_type

            this.getLists(this.queryData)
        },
        formatCheckDate(dates,year){
            let res = []
            for(let i=0;i<dates.length;i++){
                let val = dates[i]>=10?dates[i]:`0${dates[i]}`
                let item = {name:dates[i]+'月',value: `${year}-` + val}
                res.push(item)
            }
            return res;
        },
        formatDateGroup(date){
            const keys = Object.keys(date)
            let res = []
            for(let i=0;i<keys.length;i++){
                let obj = {}
                const key = keys[i]
                obj.group = key+'年'
                obj.value = this.formatCheckDate(date[key],key)
                res.push(obj)
            }
            return res
        },
        async getLists(params){
            this.loading = true
            const { data, code, msg } = await getProductList(params)
            console.log('list data', data)
            this.loading = false
			if (code === 10000 || code === 200) {
				this.listData = data;
			} else {
				this.$message({
					type: "error",
					text: msg
				});
			}
        },
        formatDays(days){
            let res = [...days]
            for(let i=0;i<res.length;i++){
                res[i]['val'] = {
                    min:res[i]['gte'],
                    max:res[i]['lte']
                }
            }
            return res
        },
        async getData(){
            const bgColor = bgColors[randomNum(0,4)]
            this.topBg = {
                background: `linear-gradient(180deg, ${bgColor} 0%, rgba(255,255,255,1) 100%)`
            }
            const id  = this.$route.query.id
            this.queryData.city = id;
            await this.getLists(this.queryData)

            const { code, data, msg } = await getHarborDetail({id})
            if (code === 10000 || code === 200) {
                this.city = data.port;

                this.filter = {
                    brand:data.cruise_company,
                    travel_days:this.formatDays(data.travel_days),
                    date:this.formatDateGroup(data.date)
                }
            } else {
                this.$message({
                    type: "error",
                    text: msg
                });
            }
            this.$nextTick(()=>{
                let line = calcTextLine(this.$refs.descRef)
                if(line>5){
                    this.infoExpandVisiblity = true
                } else {
                    this.infoExpandVisiblity = false
                }
            })
            
        }
    },
    mounted(){
        let line = calcTextLine(this.$refs.descRef)
        if(line>5){
            this.infoExpandVisiblity = true
        } else {
            this.infoExpandVisiblity = false
        }
    },
    async fetch(){
        await this.getData()
    },
    watch:{
        $route:async function(val){
            this.queryData = {
                company:[],
                days:[],
                sort_type:'4',
                sort_name:'5',
                page_index:1,
                page_size:10,
                date:[],
                city:null
            }
            this.infoExpand = false
            this.infoExpandVisiblity = false
            await this.getData()
        }
    }
})
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base/public.scss";
.top {
  padding-bottom: 40px;
  width: 100%;
}
.harbor {
  display: flex;
  align-items: flex-start;
}
.harbor .poster {
  width: 480px;
  height: 260px;
  border-radius: 4px;
  object-fit: cover;
}
.harbor .city-detail {
  flex: 1;
  padding-left: 42px;
}
.harbor .city-detail .name {
  font-size: 36px;
  color: $color-black-2;
  font-weight: 500;
  line-height: 1;
}
.harbor .city-detail .en {
  font-size: 20px;
  color: $color-black-2;
  margin-bottom: 20px;
}
.harbor .city-detail .information {
  max-height: 200px;
}
.harbor .city-detail .information .desc {
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
  margin-bottom: 15px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  white-space: pre-line;
}
.harbor .city-detail .information .more {
  width: 95px;
  height: 28px;
  font-size: 14px;
  border: 1px solid #191919;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.harbor .city-detail .information .more i {
  margin-top: 2px;
}
.harbor .city-detail .information .more:hover {
  color: $color-primary;
  border-color: $color-primary;
}
.harbor .city-detail .information.active {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  padding: 20px 10px 20px 20px;
  box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
  border-radius: 4px;
  border: 1px solid #D4D7DE;
  background-color: #fff;
  max-height: 576px;
}
.harbor .city-detail .information.active .desc {
  display: block;
  max-height: 498px;
  overflow-y: hidden;
  margin-bottom: 10px;
  padding-right: 10px;
}
.harbor .city-detail .information.active .desc::-webkit-scrollbar {
  width: 6px;
  background-color: #fff;
}
.harbor .city-detail .information.active .desc::-webkit-scrollbar-thumb {
  background: #D4D7DE;
  border-radius: 30px;
}
.harbor .city-detail .information.active .desc:hover {
  overflow-y: auto;
}
.harbor .city-detail .information.active .more {
  margin-right: 15px;
}
.harbor .city-detail .information.active .more i {
  margin-top: 0;
}
.box {
  background-color: #fff;
  padding-bottom: 98px;
}
.holday-filter {
  background: linear-gradient(180deg, #F3F5F8 0%, rgba(255,255,255,0) 100%);
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  border-radius: 20px 20px 0 0;
}
.holday-filter .filter-row {
  padding: 20px 28px;
}
</style>